import { Component, OnInit } from '@angular/core';
import { TravelService } from 'src/app/services/travel.service';
import { ActivatedRoute } from '@angular/router';
import { Travel } from 'src/app/models/travel';
import { CustomerService } from 'src/app/services/customer.service';
import { ProductService } from 'src/app/services/product.service';
import { PresentationsService } from 'src/app/services/presentations.service';
import { Presentation } from 'src/app/models/presentation';
import { Product } from 'src/app/models/product';
import { Customer } from 'src/app/models/customer';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TravelLine } from 'src/app/models/travel-line';
import { CustomerAddress } from 'src/app/models/customer-address';
import { ToastrManager } from 'ng6-toastr-notifications';
import { TravelRoute } from 'src/app/models/travel-route';
import { TravelManager } from 'src/app/classes/travel-manager';

@Component({
  selector: 'app-travel-edit',
  templateUrl: './travel-edit.component.html',
  styleUrls: ['./travel-edit.component.css']
})
export class TravelEditComponent implements OnInit {

  loading:boolean = false;
  travel:Travel;
  travelLine:TravelLine = new TravelLine();
  selectedLine:TravelLine;

  presentations:Presentation[] = [];
  products:Product[] = [];
  customers:Customer[] = [];
  customerAddresses:CustomerAddress[] = [];
  customerAddress:CustomerAddress;

  modalReference:any;
  totAxis: number;

  added:boolean = false;
  canUpdate:boolean = false;

  lineIdToEdit:number = -5;

  constructor(private travelServ:TravelService, actRoute:ActivatedRoute, private customerServ:CustomerService, private productServ:ProductService, private presentationServ:PresentationsService, private modal:NgbModal, private toastr:ToastrManager, private travelManager:TravelManager) {
    this.loading = true;
    actRoute.params.subscribe(params => {
      this.travelServ.getTravel(params.id).then(tr => {
        this.travel = tr;
        this.calcTotAxis();

        this.loading = false;
      });
    });
  }

  ngOnInit() {
    this.presentationServ.getPresentations().then(presentations => this.presentations = presentations);
    this.productServ.getProducts().then(products => this.products = products);
  }

  select(m, ln:TravelLine) {
    this.selectedLine = ln;

    if (!this.customers.length) {
      this.loading = true;
      this.customerServ.getCustomers().then(customers => {
        this.customers = customers;
        this.initializeLine(ln);
        this.loading = false;
        this.modalReference = this.modal.open(m, {size: 'lg', windowClass: 'bigger'});
      });
    } else {
      this.initializeLine(ln);
      this.modalReference = this.modal.open(m, {size: 'lg', windowClass: 'bigger'});
    }

  }

  initializeLine(ln:TravelLine) {
    this.travelLine.source_customer = ln.target_customer;
    this.travelLine.source_customer_address = ln.target_customer_address;
    this.travelLine.source_customer_address_id = ln.target_customer_address_id;
    this.travelLine.source_customer_id = ln.target_customer_id;

    this.travelLine.product_id = this.products[0].id;
    this.travelLine.presentation_id = this.presentations[0].id;

    let customer = this.customers.find(c => c.id == 8);
    this.customerAddresses = customer.directions;
    this.travelLine.target_customer_id = customer.id;
    this.travelLine.target_customer_address_id = customer.directions[0].id;

    this.travelLine.order_id = null;
    this.travelLine.travel_id = this.travel.id;

    this.changeCustomer();
  }

  changeCustomer() {
    let customer = this.customers.find(c => c.id == this.travelLine.target_customer_id);
    this.customerAddresses = customer.directions;
    this.travelLine.target_customer_id = customer.id;
    this.travelLine.target_customer_address_id = customer.directions[0].id;

    this.changeCustomerAddress();
  }

  changeCustomerAddress() {
    let customer = this.customers.find(c => c.id == this.travelLine.target_customer_id);
    this.customerAddress = customer.directions.find(d => d.id == this.travelLine.target_customer_address_id);
  }

  addLine() {
    let customer = this.customers.find(c => c.id == this.travelLine.target_customer_id);
    this.travelLine.target_customer = customer.name;
    this.travelLine.target_customer_address = customer.directions.find(d => d.id == this.travelLine.target_customer_address_id).name;
    this.travelLine.product_name = this.products.find(p => p.id == this.travelLine.product_id).name;
    this.travelLine.presentation_name = this.presentations.find(p => p.id == this.travelLine.presentation_id).name;
    this.travelLine.line = this.selectedLine.line;

    if (this.travelLine.product_name != 'Cargas Diversas' && this.travelLine.presentation_name == 'Vacio') {
      this.toastr.infoToastr('No puedes agregar la linea con la presentación vacio!');
      return;
    }
    if (this.travelLine.product_name == 'Cargas Diversas' && this.travelLine.presentation_name != 'Vacio') {
      this.toastr.infoToastr('Cargas Diversas solo debe llevar vacio!');
      return;
    }
    if (this.travelLine.ton == 0 && this.travelLine.product_name != 'Cargas Diversas') {
      this.toastr.infoToastr('No se puede agregar un articulo con peso 0!');
      return;
    }
    
    if(this.travelLine.delivery_date && this.travelLine.presentation_id && this.travelLine.presentation_name && this.travelLine.product_id && this.travelLine.product_name && this.travelLine.source_customer && this.travelLine.source_customer_address && this.travelLine.source_customer_address_id && this.travelLine.source_customer_id && this.travelLine.target_customer && this.travelLine.target_customer_address && this.travelLine.target_customer_address_id && this.travelLine.target_customer_id && this.travelLine.unit_type_presentation) {
        //agregar al viaje la línea
        if (this.travelLine.line == this.travel.lines.length - 1) {
          this.travel.lines.push(this.travelLine);
        } else {
          this.travel.lines.splice(this.travelLine.line + 1, 0, this.travelLine);

          //modificar otras líneas
          let ln = this.travel.lines[this.travelLine.line + 2];//linea siguiente
          this.lineIdToEdit = ln.id;
          ln.line += 1;
          ln.source_customer = this.travelLine.target_customer;
          ln.source_customer_id = this.travelLine.target_customer_id;
          ln.source_customer_address = this.travelLine.target_customer_address;
          ln.source_customer_address_id = this.travelLine.target_customer_address_id;
        }

        for (let i = 0; i < this.travel.lines.length; i++) {
          this.travel.lines[i].line = i;
        }

        this.travelLine = new TravelLine();
        this.modalReference.close();
        this.added = true;
    } else {
      this.toastr.infoToastr("Todos los datos son necesarios");
    }
  }

  calcExpenses() {
    this.travel.expenses = [];
    let tot = 0;
    this.loading = true;
    this.travel.lines.forEach(ln => {
      this.calcExpensesLine(ln, () => {
        tot++;
        if (tot == this.travel.lines.length) {
          this.loading = false;
          this.canUpdate = true;
        }
      });
    });
  }

  calcExpensesLine (ln:TravelLine, callback) {
    this.travel.expenses = this.travel.expenses.filter(e => e.travel_line_id != ln.id);

    this.travelManager.getRoutesByAddresses(ln.source_customer_address_id, ln.target_customer_address_id, (routes) => {
      if(routes.length == 1) {
        this.addExpenses(routes[0], ln);
      }
      callback();
    });
  }

  addExpenses (route:TravelRoute, ln:TravelLine) {
    ln.gas = route.gas;
    ln.meters = route.meters;
    ln.time = route.time;

    for(let i = 0; i < route.expenses.length; i++) {
      let exp = route.expenses[i];
      let axiSelected = exp.axis.find(a => a.axis == this.totAxis);

      this.travel.expenses.push({
        active: true,
        automatic: true,
        axis: exp.expense_type_id == 1 && axiSelected ? axiSelected.axis : 0,
        expense_id: exp.id,
        expense_name: exp.name,
        expense_type: exp.expense_type.type,
        expense_type_id: exp.expense_type.id,
        expense_type_name: exp.expense_type.name,
        first: false,
        price: exp.expense_type_id == 1 && axiSelected ? axiSelected.price : exp.price,
        quantity: exp.expense_type.name == 'Combustible' ? ln.gas : 1,
        travel_id: this.travel.id,
        travel_line_id: ln.id, 
      });
    }
  }

  calcTotAxis() {
    this.totAxis = 0;
    this.totAxis += this.travel.unity.num_rims;
    this.totAxis += this.travel.trailer_1 ? this.travel.trailer_1.num_rims : 0;
    this.totAxis += this.travel.trailer_2 ? this.travel.trailer_1.num_rims : 0;
    this.totAxis += this.travel.trailer_3 ? this.travel.trailer_1.num_rims : 0; 
  }

  update() {
    for (let i = 0; i < this.travel.lines.length; i++) {
      let ln = this.travel.lines[i];
      let hasExpenses = this.travel.expenses.filter(exp => exp.travel_line_id == ln.id).length;

      if (!hasExpenses) {
        //save here
        this.toastr.infoToastr("Todas las líneas deben tener una ruta creada!");
        return;
      }
    }

    if (this.lineIdToEdit > 0) {
      let ln = this.travel.lines.find(l => l.id == this.lineIdToEdit);
      ln.product_name = this.products.find(p => p.id == ln.product_id).name;
      ln.presentation_name = this.presentations.find(p => p.id == ln.presentation_id).name
      if (ln.product_name != 'Cargas Diversas' && ln.presentation_name == 'Vacio') {
        this.toastr.infoToastr('No puedes agregar la linea con la presentación vacio!');
        return;
      }
      if (ln.product_name == 'Cargas Diversas' && ln.presentation_name != 'Vacio') {
        this.toastr.infoToastr('Cargas Diversas solo debe llevar vacio!');
        return;
      }
      if (ln.ton == 0 && ln.product_name != 'Cargas Diversas') {
        this.toastr.infoToastr('No se puede agregar un articulo con peso 0!');
        return;
      }
    }

    //save here
    this.loading = true;
    this.travelServ.postNewLine(this.travel.id, this.travel.lines, this.travel.expenses)
      .then(resp => {
        location.reload();
      }).catch(err => {
        this.toastr.errorToastr("Oops, something went wrong!");
        this.loading = false;
      });
  }
}
